<template>
  <b-table
    id="ReturnProductAdjustmentStockTable"
    ref="ReturnProductAdjustmentStockTable"
    small
    sort-icon-left
    head-variant="light"
    :items="items"
    :fields="fields"
  >
    <template v-slot:cell(index)="row">
      <div class="d-flex align-items-center justify-content-center">
        {{ row.index + 1 }}.
      </div>
    </template>

    <template v-slot:cell(image)="row">
      <ProductImage :src="row.item.imageUrl || null" />
    </template>

    <template v-slot:cell(remainingReturnableQty)="row">
      <div class="text-left">
        {{ getRemainingReturnableQty(row) }}
      </div>
    </template>

    <template v-slot:cell(adjustmentAmount)="row">
      <InputNumberField
        :adjustStock="row.item.adjustmentAmount"
        :onChange="value => onChangeAdjustReturnStock(row, value)"
        :min="0"
        :max="getMaxReturnAmount(row)"
        :disabled="getMaxReturnAmount(row) <= 0"
      />
    </template>

    <template v-slot:cell(currentStockToAfterAdjustment)="row">
      <PreAndPostStockField
        :currentStock="convertUnitStock(row)"
        :adjustStock="-row.item.adjustmentAmount"
        :onChange="value => onChangeAdjustReturnStock(row, value)"
        :max="Number(row.item.productAvailableStock || 0)"
        :min="
          Number(row.item.productAvailableStock || 0) -
          (row.item.maxReturnAmount !== undefined
            ? Number(row.item.maxReturnAmount)
            : Number(row.item.productQtyOnGR || 0))
        "
      />
    </template>
    <template
      #custom-foot
      v-if="isAllFullyReturned"
    >
      <b-tr>
        <b-td
          :colspan="fields.length"
          class="text-center text-danger py-3"
          style="font-size: 16px;"
        >
          ใบรับสินค้าใบนี้ถูกคืนของจนครบหมดแล้ว
        </b-td>
      </b-tr>
    </template>
  </b-table>
</template>

<script>
import BigNumber from "bignumber.js";
import PreAndPostStockField from "@/components/table/stock/fields/PreAndPostStockField.vue";
import InputNumberField from "@/components/table/stock/fields/InputNumberField.vue";
import ProductImage from "@/components/table/stock/component/ProductImage.vue";

export default {
  name: "ReturnProductAdjustmentStockTable",
  components: { PreAndPostStockField, InputNumberField, ProductImage },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isAllFullyReturned() {
      if (!this.items || this.items.length === 0) return false;
      return this.items.every(
        item => Number(item.remainingReturnableQty || 0) <= 0
      );
    },
  },
  data() {
    return {
      fields: [
        {
          key: "index",
          label: "",
          class: "text-center",
          thStyle: { width: "4%" },
          tdStyle: { width: "4%" },
        },
        { key: "image", label: "", thStyle: { width: "5%" } },
        {
          key: "productNoAndName",
          label: "รหัสสินค้า - ชื่อสินค้า*",
          thStyle: { width: "22%" },
          tdStyle: { width: "22%" },
        },
        {
          key: "productQtyOnGR",
          label: "จำนวนจากใบรับสินค้า",
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
        {
          key: "remainingReturnableQty",
          label: "จำนวนคงเหลือจากใบรับสินค้า",
          thStyle: { width: "12%", textAlign: "right" },
          tdStyle: { width: "12%", textAlign: "right" },
        },
        {
          key: "adjustmentAmount",
          label: "จำนวนที่ปรับปรุง",
          thStyle: { width: "17%" },
          tdStyle: { width: "17%" },
        },
        {
          key: "currentStockToAfterAdjustment",
          label: "สต๊อก (ปัจจุบัน→หลังปรับปรุง)",
          thStyle: { width: "19%" },
          tdStyle: { width: "19%" },
        },
        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "11%" },
          tdStyle: { width: "11%" },
          tdClass: "text-wrap-cell",
        },
      ],
    };
  },
  methods: {
    getRemainingReturnableQty(row) {
      const remaining = Number(row.item.remainingReturnableQty) || 0;
      const adjustment = Number(row.item.adjustmentAmount) || 0;
      return new BigNumber(remaining).minus(adjustment).toNumber();
    },
    convertUnitStock(row) {
      return row.item.productAvailableStock;
    },
    getMaxReturnAmount(row) {
      return row.item.maxReturnAmount !== undefined
        ? Number(row.item.maxReturnAmount)
        : Number(row.item.productQtyOnGR || 0);
    },
    onChangeAdjustReturnStock(row, value) {
      // InputNumberField passes the typed positive number directly.
      // PreAndPostStockField passes the delta (afterStock - currentStock), which is negative for a return.
      // We always store adjustmentAmount as a positive number representing the decrease.
      const absNum = Math.abs(Number(value));
      this.$set(row.item, "adjustmentAmount", absNum);
      const current = Number(row.item.productAvailableStock) || 0;
      // subtract the positive amount from current stock
      const afterAdjustment = new BigNumber(current).minus(absNum).toFixed(2);
      this.$set(row.item, "currentStockToAfterAdjustment", afterAdjustment);
    },
  },
};
</script>
